'use client'
import './mascotsContent.scss'

import React, { useEffect, useState } from 'react'

import bgUrl from '@/src/shared/images/mascots/main.jpg'
import spriteUrl from '@/src/shared/images/mascots/sprite-sheet-compress.png'

import { spriteData } from './data'

const MOBILE_BREAKPOINT = 768

const MascotsContent = () => {
  const [isLoaded, setIsLoaded] = useState(false)
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const spriteImg = new Image()

    setIsLoaded(true)
    spriteImg.src = spriteUrl.src
  }, [])

  useEffect(() => {
    const onResize = () => {
      setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT)
    }

    onResize()
    window.addEventListener('resize', onResize)

    return () => window.removeEventListener('resize', onResize)
  }, [])

  useEffect(() => {
    if (!isLoaded) return

    const scene = document.querySelector('.sprite-scene') as HTMLElement | null
    if (!scene) return

    const layers = scene.querySelectorAll('.layer') as NodeListOf<HTMLElement>
    let ticking = false
    let baseScale = 1

    const updateSceneScale = () => {
      const minWidth = 375
      const maxWidth = 1920
      const minScale = 0.4469
      const maxScale = 1

      const width = window.innerWidth
      const widthProgress = Math.min(Math.max((width - minWidth) / (maxWidth - minWidth), 0), 1)

      baseScale = minScale + (maxScale - minScale) * widthProgress
    }

    const handleScroll = () => {
      const sceneTop = scene.getBoundingClientRect().top + window.scrollY
      const sceneHeight = scene.clientHeight
      const scrollY = window.scrollY
      const progress = Math.min(Math.max((scrollY - sceneTop) / sceneHeight, 0), 1)

      layers.forEach((el) => {
        const speed = parseFloat(el.dataset.speed || '1')
        const effect = el.dataset.effect || 'translate'
        const dx = parseFloat(el.dataset.dx || '0')
        const dy = parseFloat(el.dataset.dy || '0')

        if (effect === 'translate') {
          const x = dx * progress * speed
          const y = dy * progress * speed

          el.style.transform = `translate(${x}px, ${y}px) scale(${baseScale})`
        } else if (effect === 'scale') {
          const scale = 1 + progress * speed * 0.3
          el.style.transform = `scale(${baseScale * scale})`
        } else {
          el.style.transform = ''
        }
      })

      ticking = false
    }

    const onScroll = () => {
      if (!ticking) {
        requestAnimationFrame(handleScroll)
        ticking = true
      }
    }

    const onResize = () => {
      updateSceneScale()
      handleScroll()
    }

    updateSceneScale()
    handleScroll()

    window.addEventListener('scroll', onScroll, { passive: true })
    window.addEventListener('resize', onResize)

    return () => {
      window.removeEventListener('scroll', onScroll)
      window.removeEventListener('resize', onResize)
    }
  }, [isLoaded])

  return (
    <div className="mascots-wrapper">
      {isLoaded && (
        <div
          className="sprite-scene-wrapper"
          style={
            {
              '--mascots-bg-desktop': `url(${bgUrl.src})`,
            } as React.CSSProperties
          }
        >
          <div className="sprite-scene">
            {spriteData.map((sprite, i) => {
              const pos =
                isMobile && sprite.mobilePosition ? sprite.mobilePosition : sprite.position

              const commonStyle: React.CSSProperties = {
                width: sprite.w,
                height: sprite.h,
                backgroundImage: `url('${spriteUrl.src}')`,
                backgroundPosition: `-${sprite.x}px -${sprite.y}px`,
                backgroundRepeat: 'no-repeat',
                willChange: 'transform',
                position: 'absolute',
                top: pos?.top,
                bottom: pos?.bottom,
                left: pos?.right !== undefined ? undefined : pos?.left,
                right: pos?.right,
              }

              const dataAttrs = {
                'data-speed': sprite.speed ?? 1,
                'data-effect': sprite.effect ?? 'translate',
                'data-dx': sprite.dx ?? 0,
                'data-dy': sprite.dy ?? 0,
              }

              return (
                <div
                  key={i}
                  className={`sprite ${sprite.class} layer`}
                  {...dataAttrs}
                  style={commonStyle}
                />
              )
            })}
          </div>
        </div>
      )}
      <div className="heading-gradient" />
    </div>
  )
}

export default MascotsContent
